var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShowMe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 12.5L16.5 5V19L1 12.5Z",
    fill: "url(#paint0_radial_5674_133469)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9519 6.21188C14.9001 8.53735 13.0373 10.4001 10.7119 11.4519L9.5 12L10.7119 12.5481C13.0373 13.5999 14.9001 15.4627 15.9519 17.7881L16.5 19L17.0481 17.7881C18.0999 15.4627 19.9627 13.5999 22.2881 12.5481L23.5 12L22.2881 11.4519C19.9627 10.4001 18.0999 8.53735 17.0481 6.21188L16.5 5L15.9519 6.21188Z",
    fill: "#C4AAEB"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_5674_133469",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.1567 12) rotate(-180) scale(15.791 19.32)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D5BD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.619561,
    stopColor: "#002D72",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#002D72",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowMe);
export default __webpack_public_path__ + "static/media/show-me.a4de8e42388d16096de7e59f7398d760.svg";
export { ForwardRef as ReactComponent };